import styled from '@nobia/zeus-components/lib/styled'
import PropTypes from 'prop-types'
import React from 'react'

const Line = styled.line`
  transition: transform 400ms ease-in-out;
  transform-origin: center;
`
const Line2 = styled.line`
  transition: transform 400ms ease-in-out;
  transform-origin: center;
  ${p =>
    p.rotateSVG &&
    `
        transform: rotate(-90deg);
    `}
`

const DEFAULT_STYLE = {
  stroke: 'currentColor',
  strokeWidth: 10,
  fill: 'none',
}

const OpenCloseIcon = ({ isClosed, size, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Checkmark</title>
    <g id="Check" {...DEFAULT_STYLE} {...style}>
      <Line x1="0" x2="100" y1="50" y2="50" />
      <Line2 x1="0" x2="100" y1="50" y2="50" rotateSVG={!isClosed} />
    </g>
  </svg>
)

OpenCloseIcon.defaultProps = {
  isClosed: false,
  size: 24,
  style: {},
}

OpenCloseIcon.propTypes = {
  isClosed: PropTypes.bool,
  size: PropTypes.number,
  style: PropTypes.shape({}),
}

export default OpenCloseIcon
